import { ServiceCompWrapper } from "../../styles/StyledComponents/ServiceCompWrapper";
import { cardMock } from "../../ui/json/demo.mock";
import CommonCard from "../CommonCard/CommonCard";
import CommonHeading from "../CommonHeading/CommonHeading";

const ServiceComp = () => {
  return (
    <ServiceCompWrapper className="cmn_gap_btm">
      <div className="container">
        <div className="service_heading">
          <CommonHeading
            isPrimary
            title="Our Services"
            paratext="EMIIT delivers custom web design, development, UI/UX, e-commerce solutions, and reliable support — everything you need for a high-performing online presence."
          />
        </div>
        <div className="row services_row">
          {cardMock?.map((data, index) => (
            <div className="service_card_col" key={index}>
              <CommonCard typeofCard={"service"} {...data} />
            </div>
          ))}
        </div>
      </div>
    </ServiceCompWrapper>
  );
};

export default ServiceComp;
